<template>
  <div class="activate-page">
    <div class="nav-bar">
      <div class="nav-items">
        <div class="nav-item" @click="navigateToListen">听</div>
        <div class="nav-item">看</div>
        <div class="nav-item active">激活</div>
      </div>
      <div class="auth-buttons">
        <div class="auth-button">登录</div>
        <div class="auth-button">注册</div>
      </div>
    </div>
    
    <div class="content">
      <div class="activation-container">
        <h2 class="activation-title">课程激活</h2>
        
        <div v-if="isActivated" class="activation-success">
          <div class="success-icon">✓</div>
          <h3>您的课程已成功激活</h3>
          <p>现在您可以访问所有课程内容</p>
          <button class="action-button" @click="navigateToListen">返回听课页面</button>
        </div>
        
        <div v-else class="activation-form">
          <p class="activation-description">请输入您的激活码以解锁所有课程</p>
          
          <div class="input-group">
            <input
              type="text"
              v-model="activationCode"
              placeholder="请输入激活码"
              :class="{ 'error': activationError }"
            />
            <span v-if="activationError" class="error-message">激活码无效，请重试</span>
          </div>
          
          <button class="action-button" @click="activateCourses">激活课程</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ActivatePage',
  data() {
    return {
      activationCode: '',
      activationError: false
    }
  },
  computed: {
    ...mapGetters(['isActivated'])
  },
  methods: {
    async activateCourses() {
      if (!this.activationCode.trim()) {
        this.activationError = true
        return
      }
      
      const result = await this.$store.dispatch('verifyActivationCode', this.activationCode)
      if (!result) {
        this.activationError = true
      }
    },
    navigateToListen() {
      // 在实际应用中，应该使用vue-router进行导航
      // 这里我们通过事件通知父组件切换页面
      this.$emit('navigate', 'listen')
    }
  },
  mounted() {
    this.$store.dispatch('checkActivationStatus')
  }
}
</script>

<style scoped>
.activate-page {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #fff;
}

.nav-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.nav-items {
  display: flex;
  gap: 40px;
}

.nav-item {
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  position: relative;
}

.nav-item.active {
  font-weight: bold;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000;
}

.auth-buttons {
  display: flex;
  gap: 20px;
}

.auth-button {
  cursor: pointer;
  font-size: 16px;
}

.content {
  flex: 1;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.activation-container {
  max-width: 500px;
  width: 100%;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background-color: #fff;
}

.activation-title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 24px;
}

.activation-description {
  margin-bottom: 20px;
  font-size: 16px;
  color: #666;
  text-align: center;
}

.input-group {
  margin-bottom: 20px;
}

input {
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
}

input.error {
  border-color: #f44336;
}

.error-message {
  color: #f44336;
  font-size: 14px;
  display: block;
  margin-top: 6px;
}

.action-button {
  width: 100%;
  padding: 12px 16px;
  background-color: #2c3e50;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.action-button:hover {
  background-color: #1a2530;
}

.activation-success {
  text-align: center;
}

.success-icon {
  width: 60px;
  height: 60px;
  background-color: #4caf50;
  color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto 20px;
  font-size: 30px;
}

.activation-success h3 {
  margin-bottom: 10px;
  font-size: 20px;
}

.activation-success p {
  color: #666;
  margin-bottom: 20px;
}
</style> 